import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Button as MuiButton,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import { FolderOpen as FolderOpenIcon, CameraAlt as CameraAltIcon } from '@mui/icons-material';
import { Typography } from '@tucar/pit-stop';

const UploadMethodDialog = ({ open, onClose, onMethodSelect, isUploading }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Seleccionar origen</DialogTitle>
      <DialogContent>
        {isUploading && (
          <Box sx={{ textAlign: 'center', py: 3 }}>
            <CircularProgress />
            <Typography fontSize={14} style={{ marginTop: '16px' }}>
              Se está subiendo un documento, por favor espere...
            </Typography>
          </Box>
        )}

        {!isUploading && (
          <Box sx={{ py: 2 }}>
            <Typography fontSize={16} style={{ marginBottom: '24px', textAlign: 'center' }}>
              ¿Cómo deseas subir el documento?
            </Typography>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        {!isUploading && (
          <Box sx={{ flexDirection: 'column', gap: 1, p: 2, width: 'min-content' }}>
            <MuiButton onClick={onClose} color="primary" sx={{ width: '100%' }}>
              Cancelar
            </MuiButton>

            <MuiButton
              onClick={() => onMethodSelect('file')}
              startIcon={<FolderOpenIcon />}
              color="primary"
              sx={{ width: '100%' }}
            >
              Archivo
            </MuiButton>

            <MuiButton
              onClick={() => onMethodSelect('camera')}
              startIcon={<CameraAltIcon />}
              color="primary"
              sx={{ width: '100%' }}
            >
              Cámara
            </MuiButton>
          </Box>
        )}
      </DialogActions>
    </Dialog>
  );
};

UploadMethodDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onMethodSelect: PropTypes.func.isRequired,
  selectedDocument: PropTypes.shape({
    displayName: PropTypes.string,
  }),
  isUploading: PropTypes.bool.isRequired,
};

UploadMethodDialog.defaultProps = {
  selectedDocument: null,
};

export default UploadMethodDialog;
